import { render } from "./langControl.vue?vue&type=template&id=4c62be06"
import script from "./langControl.vue?vue&type=script&lang=js"
export * from "./langControl.vue?vue&type=script&lang=js"

import "./langControl.vue?vue&type=style&index=0&id=4c62be06&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__